import React from "react";
import { useParams, Link } from "react-router-dom";
import "../styles/pages.css";

const VALID = new Set([
  "case-study-amirs-laundry","case-study-aurina-labs","case-study-be-story",
  "case-study-blueverse","case-study-canbridge","case-study-chf-terracotta",
  "case-study-desert-hive","case-study-foret","case-study-ird","case-study-ksht",
  "case-study-magical-emotions","case-study-recall-desert","case-study-recall-shoreline",
]);

export default function CaseStudy() {
  const { slug } = useParams();
  const ref = React.useRef(null);
  React.useEffect(() => { window.scrollTo({ top: 0 }); }, [slug]);

  if (!VALID.has(slug)) {
    return (
      <div style={{ padding: "5rem 2rem", textAlign: "center" }} data-testid="case-not-found">
        <h1 style={{ fontFamily: "var(--serif)", fontSize: "2rem", marginBottom: "1rem" }}>Case study not found</h1>
        <Link to="/work" className="btn-primary">Back to all work</Link>
      </div>
    );
  }

  return (
    <div className="kmr-page case-study-wrap" data-testid="case-study-page">
      <div className="case-back">
        <Link to="/work" data-testid="case-back-link">← Back to all work</Link>
      </div>
      <iframe
        key={slug}
        ref={ref}
        title={slug}
        src={`/case-studies/${slug}.html`}
        className="case-study-iframe"
        data-testid="case-study-iframe"
      />
    </div>
  );
}
